import {
  Button,
  Stack,
  TableCell,
  TableRow,
  Typography
} from '@mui/material';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';

import { TransactionType } from '@src/lib/types/purchases';

const TableRowItem = (props: TransactionType) => {
  const userID = props.user.id;

  const navigate = useNavigate();
  const location = useLocation();

  const onViewUserDetails = () => {
    navigate(`/dashboard/users?u=${userID}`);
  }

  if(location.pathname === "/dashboard/purchase/gold-purchases"){
    return (
      <TableRow hover tabIndex={-1} role="checkbox" >
        <TableCell align="left">{props.id}</TableCell>
        <TableCell onClick={onViewUserDetails} component="th" scope="row" padding="none">
          <Stack direction="row" alignItems="center">
            <Button>
              <Typography variant="subtitle2" noWrap sx={{ textDecoration: 'underline' }}>
                {userID}
              </Typography>
            </Button>
          </Stack>
        </TableCell>
        <TableCell align="left">{props.user?.palmsId}</TableCell>
        <TableCell align="left">{props.user.displayName}</TableCell>
        <TableCell align="left">{props.productName}</TableCell>
        <TableCell align="left">{props.goldAmount}</TableCell>
        <TableCell align="left">{redeemStatusName(props.redeemStatusID)}</TableCell>
        <TableCell align="left">{moment.parseZone(props.requestDate).format("MM-DD-YYYY hh:mm A")}</TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow hover tabIndex={-1} role="checkbox" >
      <TableCell align="left">{props.id}</TableCell>
      <TableCell onClick={onViewUserDetails} component="th" scope="row" padding="none">
        <Stack direction="row" alignItems="center">
          <Button>
            <Typography variant="subtitle2" noWrap sx={{ textDecoration: 'underline' }}>
              {userID}
            </Typography>
          </Button>
        </Stack>
      </TableCell>
      <TableCell align="left">{props.user?.palmsId}</TableCell>
      <TableCell align="left">{props.user.displayName}</TableCell>
      <TableCell align="left">{props.purchaseItemName}</TableCell>
      <TableCell align="left">{props.amount}</TableCell>
      <TableCell align="left">{props.status}</TableCell>
      <TableCell align="left">{moment.parseZone(props.transactionDate).format("MM-DD-YYYY hh:mm A")}</TableCell>
    </TableRow>
  );
}

export const redeemStatusName = (status: number) => {
  switch (status) {
    case 1:
      return "Request submit";
    case 2:
      return "Email verified";
    case 3:
      return "Review in progress";
    case 4:
      return "Request approved";
    case 5:
      return "Completed";
    case 6:
      return "Request rejected";
  }
};

export default TableRowItem;
